/* Iceberg */
import { IconName, IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';

/**
 * Renders an icon component specifically styled for sidebar list item usage
 * @param {Object} props - Component props
 * @param {number} props.size - The size of the icon to display
 * @param {IconName} props.src - The source/name of the icon to display
 * @returns {JSX.Element} An IconWithVariant component configured for sidebar list item display
 */
export const IconForSidebarListItem = ({
    size = FontSizes[2],
    src
}: {
    size?: number;
    src: IconName;
}): JSX.Element => (
    <IconWithVariant
        data-testid={`iconForSidebarListItem_${src}`}
        variant="sidebar"
        src={src}
        size={size}
        wrapperProps={{
            display: 'flex',
            justifyContent: 'space-around'
        }}
    />
);

/**
 * Renders an icon component specifically styled for tab usage in the sidebar
 * @param {Object} props - Component props
 * @param {number} props.size - The size of the icon to display
 * @param {IconName} props.src - The source/name of the icon to display
 * @returns {JSX.Element} An IconWithVariant component configured for tab display
 */
export const IconForTab = ({
    size = FontSizes[2],
    src
}: {
    size?: number;
    src: IconName;
}): JSX.Element => (
    <IconWithVariant
        data-testid={`iconForTab_${src}`}
        variant="sidebar"
        src={src}
        size={size}
        wrapperProps={{
            display: 'flex',
            justifyContent: 'space-around',
            minWidth: '36px'
        }}
    />
);
